module.exports = __webpack_public_path__ + "static/ml-6b01e10d2358f1054f4ef6cad0709e8a.png";